import { Button } from '@/components/ui/button'
import { Download, Loader2 } from 'lucide-react'
import { useExportarSolicitudes, useExportarGuiaEnvio } from '../hooks/useSolicitudes'

interface ExportarButtonsProps {
  campaniaId: number
}

export function ExportarButtons({ campaniaId }: ExportarButtonsProps) {
  const exportarSolicitudes = useExportarSolicitudes()
  const exportarGuia = useExportarGuiaEnvio()

  return (
    <div className="flex items-center gap-2">
      <Button
        size="sm"
        className="bg-teal-800 hover:bg-teal-900 text-white"
        onClick={() => exportarSolicitudes.mutate(campaniaId)}
        disabled={exportarSolicitudes.isPending}
      >
        {exportarSolicitudes.isPending
          ? <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          : <Download className="mr-2 h-4 w-4" />
        }
        Exportar Solicitudes
      </Button>
      <Button
        size="sm"
        className="bg-teal-800 hover:bg-teal-900 text-white"
        onClick={() => exportarGuia.mutate({ campaniaId })}
        disabled={exportarGuia.isPending}
      >
        {exportarGuia.isPending
          ? <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          : <Download className="mr-2 h-4 w-4" />
        }
        Exportar Guía Envío
      </Button>
    </div>
  )
}
